module.exports = __webpack_public_path__ + "img/6842902.png";